import { Component } from '@angular/core';

@Component({
  selector: 'lcl-empty-list-placeholder',
  templateUrl: './lcl-empty-list-placeholder.component.html',
  styleUrls: ['./lcl-empty-list-placeholder.component.scss'],
})
export class LclEmptyListPlaceholderComponent {}
